import React, { useEffect, useState } from 'react';
import api from '../api';

export default function WarehouseAssignment({ order, onAssigned }) {
  const [workers, setWorkers] = useState([]);
  const [workerId, setWorkerId] = useState(order.collectorId ? String(order.collectorId) : '');
  const [points, setPoints] = useState(() => Object.fromEntries(
    (order.sellerOrders || []).map(seller => [seller.id, seller.collectionPoint || ''])
  ));
  const missingPoints = order.warehouseReceiptRequired && order.sellerOrders.some(seller => !points[seller.id]?.trim());
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    api.get('/api/admin/workers').then(({ data }) => {
      if (active) setWorkers(data.filter(worker => worker.active));
    }).catch(() => {
      if (active) setError('Не удалось загрузить список сборщиков.');
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const addWorker = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    const fields = new FormData(form);
    setBusy(true);
    setError('');
    try {
      const { data } = await api.post('/api/admin/workers', {
        name: fields.get('name').trim(), phone: fields.get('phone').trim(), password: fields.get('password'),
      });
      setWorkers(list => [...list, data]);
      setWorkerId(String(data.id));
      form.reset();
      form.closest('details').open = false;
    } catch (e) {
      setError(e.response?.data?.details?.[0]?.message || e.response?.data?.error || 'Не удалось создать сборщика.');
    } finally { setBusy(false); }
  };

  const assign = async () => {
    setBusy(true);
    setError('');
    try {
      await api.patch(`/api/admin/orders/${order.id}/assign-worker`, {
        collectorId: Number(workerId),
        ...(order.warehouseReceiptRequired && { points }),
      });
      await onAssigned();
    } catch (e) {
      setError(e.response?.data?.error || 'Не удалось назначить сборщика.');
    } finally { setBusy(false); }
  };

  return <section className="warehouse-shipment-panel">
    <h3>Сборка заказа</h3>
    {error && <p role="alert">{error}</p>}
    {loading ? <p role="status">Загружаем сборщиков…</p> : <>
      {order.warehouseReceiptRequired && <div className="warehouse-dimensions">
        {order.sellerOrders.map(seller => <label key={seller.id}>
          Место получения у продавца {seller.seller?.name || seller.sellerId}
          <input maxLength={400} value={points[seller.id] || ''} disabled={busy}
            onChange={event => setPoints(values => ({ ...values, [seller.id]: event.target.value }))} />
        </label>)}
      </div>}
      <div className="warehouse-label-controls">
        <label>Сборщик <select value={workerId} onChange={e => setWorkerId(e.target.value)} disabled={busy}>
          <option value="">Выберите сборщика</option>
          {workers.map(worker => <option key={worker.id} value={worker.id}>{worker.name}</option>)}
        </select></label>
        <button type="button" className="btn btn-primary" disabled={!workerId || busy || missingPoints} onClick={assign}>Назначить сборщика</button>
      </div>
      <details>
        <summary>Добавить сборщика</summary>
        <form onSubmit={addWorker}>
          <div className="warehouse-dimensions">
            <label>Имя<input name="name" required maxLength={100} /></label>
            <label>Телефон<input name="phone" type="tel" required maxLength={32} /></label>
            <label>Пароль<input name="password" type="password" autoComplete="new-password" required minLength={8} maxLength={72} /></label>
          </div>
          <button className="btn btn-primary" disabled={busy}>Создать сборщика</button>
        </form>
      </details>
    </>}
  </section>;
}
